// Max number of dots to render without significant lag on 4x slowed down CPU
export const MAX_NUMBER_OF_DOTS_WITHOUT_LAG = 4000;
